import React, { useState } from 'react';
import { Slideover2 } from '@nalgoo-ui-private/nalgoo-ui';
import { BanknotesIcon } from '@heroicons/react/16/solid';

export default function SalaryDetail({ info, salary, jobTitle, color }) {
	const [open, setOpen] = useState(false);

	if (!info && !salary) {
		return null;
	}

	if (!info || !salary) {
		return (
			<div className="mt-2 flex items-center text-sm @sm:mr-6">
				<BanknotesIcon
					style={{ color }}
					aria-hidden="true"
					className="mr-1.5 h-5 w-5 flex-shrink-0"
				/>
				{info || salary}
			</div>
		);
	}

	return (
		<>
			<div className="mt-2 flex items-center text-sm @sm:mr-6">
				<BanknotesIcon
					style={{ color }}
					aria-hidden="true"
					className="mr-1.5 h-5 w-5 flex-shrink-0"
				/>
				<button className="underline" onClick={() => setOpen(true)}>{salary}</button>
			</div>
			{/* <button onClick={() => setOpen(true)}><Icon.EllipsisVertical variant="solid" color={color} className="h-6 w-6" style={{ color }} /></button> */}
			<Slideover2
				open={open}
				onClose={() => setOpen(false)}
			>
				<Slideover2.Panel>
					<Slideover2.Header>
						{jobTitle}
					</Slideover2.Header>
					<Slideover2.Body padded>
						{info}
					</Slideover2.Body>
				</Slideover2.Panel>
			</Slideover2>
		</>
	);
}
